import { LazyLoad } from '@petconsole/pure-fe-mui';

const PetTrainerAdmin = LazyLoad(() => import('./PetTrainerAdmin'));

export { PetTrainerAdmin };
